import { clientApi } from '../../configuration';
import { getPermissionsHook } from '../../utils';

type PermissionCodes =
  | 'CAN_EDIT_EMAIL'
  | 'CAN_EDIT_PASSWORD'
  | 'CAN_EDIT_BIRTHDATE'
  | 'CAN_EDIT_NAME'
  | 'DISPLAY_PLAYLISTS'
  | 'ACCESS_TALENTS_MARKETPLACE'
  | 'ACCESS_JOB_POSTINGS'
  | 'ACCESS_MATCH_WITH_EMPLOYER'
  | 'ACCESS_MATCH_WITH_CANDIDATE'
  | 'ACCESS_JOB_AUTO_APPLY'
  | 'CAN_SEE_TUTOR_DASHBOARD'
  | 'CAN_SEE_MENTOR_DASHBOARD'
  | 'CAN_SEE_ORGANIZATION_DASHBOARD'
  | 'CAN_EDIT_COURSE'
  | 'CAN_SEE_ADMIN_DASHBOARD'
  | 'BYPASS_HIRING_INTENT_WALL'
  | 'CAN_CREATE_TRAINING_MODULE'
  | 'CAN_EDIT_TRAINING_MODULE';

const usePermissions = getPermissionsHook<PermissionCodes>({
  entityName: 'permissions',
  fetch: () => clientApi.getOCClient().helpers.user.me.getPermissions(),
});

export default usePermissions;
